import { Skeleton } from 'antd';
import moment, { Moment } from 'moment';
import { useEffect, useState } from 'react';

import {
  Button,
  Descriptions,
  FormatItem,
  Progress,
  Title,
} from '../../../components/index';
import { OperationCalculusType, StoppageType } from '../../../types';
import { convertMinutesToStringHours } from '../../../utils/utils';
import { ProgressLegend } from '../../../domains/operation/OperationsData/styles';

const { Item } = Descriptions;

type OperationResumeProps = {
  operationCalculusData: OperationCalculusType;
  setIsVisibleStoppagesDrawer: (value: boolean) => void;
  stoppages: StoppageType[];
  isLoadingOperationCalculus: boolean;
  operationType: 'COMMON' | 'VEHICLES' | 'LIQUID_BULK' | 'SOLID_BULK' | any;
  operationStart?: string | Moment | null;
  operationFinish?: string | Moment | null;
};

export function OperationResume(props: OperationResumeProps) {
  const {
    operationCalculusData,
    setIsVisibleStoppagesDrawer,
    stoppages,
    isLoadingOperationCalculus,
    operationType,
    operationStart,
    operationFinish,
  } = props;

  const formatProgressText = (percent?: number) => {
    return `${percent}% operado`;
  };

  return isLoadingOperationCalculus ? (
    <Skeleton active />
  ) : (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        backgroundColor: '#EBF2F7',
        padding: '16px',
      }}
    >
      <Title>RESUMO DA OPERAÇÃO</Title>
      {operationCalculusData?.operation_products &&
      operationCalculusData?.operation_products.length > 0 ? (
        <>
          <Progress
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '5px',
            }}
            percent={
              operationCalculusData?.vehicles_progress > 0
                ? operationCalculusData?.vehicles_progress
                : operationCalculusData?.operation_progress || 0
            }
            status="active"
            format={formatProgressText}
          />
          {operationCalculusData?.total_vehicle_amount_operated > 0 ? (
            <ProgressLegend>
              <div className="legend-item">
                <div className="square green" />
                <span>
                  Total operado:
                  <strong>
                    {` ${operationCalculusData?.total_vehicle_amount_operated?.toLocaleString(
                      'pt-BR'
                    )} ${operationCalculusData?.unit}` || '-'}
                  </strong>
                </span>
              </div>
              <div className="legend-item">
                <div className="square gray" />
                <span>
                  Total manifestado:
                  <strong>
                    {` ${operationCalculusData?.total_vehicle_manifested?.toLocaleString(
                      'pt-BR'
                    )} ${operationCalculusData?.unit}` || '-'}
                  </strong>
                </span>
              </div>
              <div
                className="legend-item"
                title="Carga manifestada que não será operada (informada via Supressão de Carga ANTAQ)"
              >
                <div className="square red" />
                <span>
                  Total suprimido:
                  <strong>
                    {` ${(
                      operationCalculusData?.total_suppressed || 0
                    ).toLocaleString('pt-BR')} ${
                      operationCalculusData?.unit || 'ton'
                    }`}
                  </strong>
                </span>
              </div>
            </ProgressLegend>
          ) : (
            <ProgressLegend>
              <div className="legend-item">
                <div className="square green" />
                <span>
                  Total operado:
                  <strong>
                    {` ${operationCalculusData?.total_movimented?.toLocaleString(
                      'pt-BR'
                    )} ${operationCalculusData?.unit}` || '-'}
                  </strong>
                </span>
              </div>
              <div className="legend-item">
                <div className="square gray" />
                <span>
                  Total manifestado:
                  <strong>
                    {` ${operationCalculusData?.total_weight?.toLocaleString(
                      'pt-BR'
                    )} ${operationCalculusData?.unit}` || '-'}
                  </strong>
                </span>
              </div>
              <div
                className="legend-item"
                title="Carga manifestada que não será operada (informada via Supressão de Carga ANTAQ)"
              >
                <div className="square red" />
                <span>
                  Total suprimido:
                  <strong>
                    {` ${(
                      operationCalculusData?.total_suppressed || 0
                    ).toLocaleString('pt-BR')} ${
                      operationCalculusData?.unit || 'ton'
                    }`}
                  </strong>
                </span>
              </div>
            </ProgressLegend>
          )}
        </>
      ) : (
        <>
          <Progress
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '5px',
            }}
            percent={
              // eslint-disable-next-line no-unsafe-optional-chaining
              (operationCalculusData?.total_container_total_handled /
                // eslint-disable-next-line no-unsafe-optional-chaining
                operationCalculusData?.total_container_manifested) *
                100 || 0
            }
            status="active"
            format={formatProgressText}
          />
          <ProgressLegend>
            <div className="legend-item">
              <div className="square green" />
              <span>
                Total operado:
                <strong>
                  {` ${operationCalculusData?.total_containers?.toLocaleString(
                    'pt-BR'
                  )} un` || '-'}
                </strong>
              </span>
            </div>
            <div className="legend-item">
              <div className="square gray" />
              <span>
                Total previsto:
                <strong>
                  {` ${operationCalculusData?.total_container_manifested?.toLocaleString(
                    'pt-BR'
                  )} un` || '-'}
                </strong>
              </span>
            </div>
            <div
              className="legend-item"
              title="Contêineres manifestados que não serão operados (informados via Supressão de Carga ANTAQ)"
            >
              <div className="square red" />
              <span>
                Total suprimido:
                <strong>
                  {` ${(
                    operationCalculusData?.total_suppressed_containers || 0
                  ).toLocaleString('pt-BR')} un`}
                </strong>
              </span>
            </div>
          </ProgressLegend>
        </>
      )}
      {operationCalculusData?.operation_products &&
        operationCalculusData?.operation_products.length > 0 && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              backgroundColor: '#fff',
              padding: '4px 8px',
              marginBlockEnd: '4px',
              borderRadius: '4px',
              paddingLeft: '8px',
            }}
          >
            <Title>Progresso por produto</Title>
            <Descriptions>
              {operationCalculusData?.operation_products?.map((item) => (
                <>
                  <Item key={item.id} label={item.cargo_type}>
                    <FormatItem>
                      {' '}
                      {operationCalculusData?.vehicles_progress > 0
                        ? operationCalculusData?.vehicles_progress
                        : item.product_progress}
                      % operado
                    </FormatItem>
                  </Item>
                  <Item key={item.id} label="Total Movimentado">
                    <FormatItem>
                      {item.total_movimented?.toLocaleString('pt-BR')}{' '}
                      {operationCalculusData?.unit}
                    </FormatItem>
                  </Item>
                  <Item key={item.id} label="Peso Total Ce Mercante">
                    <FormatItem>
                      {item.total_weight?.toLocaleString('pt-BR')}
                      {' ton'}
                    </FormatItem>
                  </Item>
                  <Item key={item.id} label="Total no Manifesto">
                    <FormatItem>
                      {item.total_manifested?.toLocaleString('pt-BR')}
                      {' ton'}
                    </FormatItem>
                  </Item>
                  <Item key={item.id} label="Volume Total Manifestado">
                    <FormatItem>
                      {item.merchant_total_volume?.toLocaleString('pt-BR')}{' '}
                    </FormatItem>
                  </Item>
                  <Item key={item.id} label="Quantidade Total Manifestado">
                    <FormatItem>
                      {item.merchant_total_amount?.toLocaleString('pt-BR')}{' '}
                    </FormatItem>
                  </Item>
                  {item.cargo_type === 'VEÍCULOS' && (
                    <>
                      <Item
                        key={item.id}
                        label="Quantidade de veículos operados"
                      >
                        <FormatItem>
                          {item.vehicle_amount_operated?.toLocaleString(
                            'pt-BR'
                          )}
                          {' un'}
                        </FormatItem>
                      </Item>
                      <Item
                        key={item.id}
                        label="Quantidade de veículos não operados"
                      >
                        <FormatItem>
                          {item.vehicle_amount_not_operated?.toLocaleString(
                            'pt-BR'
                          )}
                          {' un'}
                        </FormatItem>
                      </Item>
                    </>
                  )}
                </>
              ))}
            </Descriptions>
          </div>
        )}
      {(!operationCalculusData?.operation_products ||
        operationCalculusData?.operation_products.length === 0) && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            gap: '8px',
            width: '100%',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              backgroundColor: '#fff',
              paddingBlockStart: '4px',
              paddingInlineStart: '8px',
            }}
          >
            <Title>Total Movimentado</Title>
            <Descriptions column={1}>
              <Item label="Contêineres operados">
                <FormatItem>
                  {operationCalculusData?.total_containers?.toLocaleString(
                    'pt-BR'
                  )}
                  {' un'}
                </FormatItem>
              </Item>
              <Item label="Peso Bruto Total">
                <FormatItem>
                  {operationCalculusData?.total_containers_weight?.toLocaleString(
                    'pt-BR'
                  )}
                  {' ton'}
                </FormatItem>
              </Item>
            </Descriptions>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              backgroundColor: '#fff',
              paddingBlockStart: '4px',
              paddingInlineStart: '8px',
            }}
          >
            <Title>Carga Manifestada</Title>
            <Descriptions column={1}>
              <Item label="Contêineres manifestados">
                <FormatItem>
                  {operationCalculusData?.total_container_manifested?.toLocaleString(
                    'pt-BR'
                  )}
                  {' un'}
                </FormatItem>
              </Item>
              <Item label="Status do manifesto">
                <FormatItem>
                  {Math.min(
                    (operationCalculusData?.total_container_manifested ?? 0) > 0
                      ? Math.round(
                          ((operationCalculusData?.total_container_total_handled ??
                            0) /
                            (operationCalculusData?.total_container_manifested ??
                              1)) *
                            100
                        )
                      : 0,
                    100
                  )}
                  {'% '}
                  <span style={{ color: '#9ca3af', fontSize: '12px' }}>
                    (
                    {operationCalculusData?.total_container_total_handled?.toLocaleString(
                      'pt-BR'
                    )}{' '}
                    de{' '}
                    {operationCalculusData?.total_container_manifested?.toLocaleString(
                      'pt-BR'
                    )}{' '}
                    un)
                  </span>
                </FormatItem>
              </Item>
            </Descriptions>
          </div>
        </div>
      )}
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '8px',
          width: '100%',
        }}
      >
        {operationType !== 'LIQUID_BULK' && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              backgroundColor: '#fff',
              paddingBlockStart: '4px',
              paddingInlineStart: '8px',
            }}
          >
            <Title>Produção por período</Title>
            <Descriptions column={2}>
              {operationCalculusData?.work_periods &&
              operationCalculusData?.work_periods.length > 0 ? (
                operationCalculusData?.work_periods?.map((item, index) => (
                  <Item key={item.id} label={`Período ${index + 1}`}>
                    <FormatItem>
                      {item.total_movimented?.toLocaleString('pt-BR')}{' '}
                      {operationCalculusData?.unit}
                    </FormatItem>
                  </Item>
                ))
              ) : (
                <span>Não existem períodos com movimentações cadastradas</span>
              )}
            </Descriptions>
          </div>
        )}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#fff',
            paddingBlockStart: '4px',
            paddingInlineStart: '8px',
          }}
        >
          <Title>Produtividade</Title>
          <Descriptions column={1}>
            <Item label="Produtividade liquida">
              <FormatItem>
                {operationCalculusData?.total_net_production &&
                  `${operationCalculusData?.total_net_production.toLocaleString(
                    'pt-BR'
                  )} ${operationCalculusData?.unit}/h`}
              </FormatItem>
            </Item>
            <Item label="Produtividade bruta">
              <FormatItem>
                {operationCalculusData?.total_gross_production &&
                  `${operationCalculusData?.total_gross_production.toLocaleString(
                    'pt-BR'
                  )} ${operationCalculusData?.unit}/h`}
              </FormatItem>
            </Item>
          </Descriptions>
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: '#fff',
          paddingBlockStart: '4px',
          paddingInlineStart: '8px',
        }}
      >
        <Title>Tempos</Title>
        <Descriptions column={3}>
          <Item label="Duração da operação">
            <FormatItem>
              {convertMinutesToStringHours(operationCalculusData.total_time)}
            </FormatItem>

            {/* <FormatItem>
              {operationCalculusData?.total_time &&
                `${operationCalculusData?.total_time}h`}
            </FormatItem> */}
          </Item>
          <Item label="Horas paralisadas">
            <div>
              <FormatItem>
                {convertMinutesToStringHours(
                  operationCalculusData.total_stoppage_time
                )}
              </FormatItem>
              <Button
                style={{ marginTop: '-8px', marginLeft: '-10px' }}
                type="link"
                onClick={() => setIsVisibleStoppagesDrawer(true)}
                disabled={stoppages.length === 0}
              >
                {stoppages.length === 0
                  ? 'Nenhuma paralisação'
                  : stoppages.length === 1
                  ? '1 paralisação'
                  : `(${stoppages.length} Paralisações)`}
              </Button>
            </div>
          </Item>
          <Item label="Horas operacionais">
            <FormatItem>
              {operationCalculusData?.total_time &&
                convertMinutesToStringHours(
                  (operationCalculusData?.total_time || 0) -
                    (operationCalculusData?.total_stoppage_time || 0)
                )}
            </FormatItem>
          </Item>
        </Descriptions>
      </div>
    </div>
  );
}
